<div id="app-root" class="wrapper" [class.responsible]="responsible">
  <app-playlist *ngIf="! error && enable && ready"></app-playlist>
  <app-error [error]="error" *ngIf="error"></app-error>
</div>